/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DRIVER_OPERATION_TYPE } from "./data";
import { FinanceHoverIcon } from "../../../../Common/Svgs/FinanceIcon";
import CustomTable from "../../../../Core/Components/CustomTable";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";
import {
  getDriverPaymentDetailsKPI,
  getDriverSessionPaymentDetails,
  getDriverTripPaymentDetails,
} from "../../../../Redux/APIs/revenueAPI";
import useDebounce from "../../../../Core/hooks/useDebounce";
import { PaymentDetailsKPIData } from "../../PaymentList/data";
import CustomKPI from "../../../../Core/Components/CustomKpi";
import DriverDetailHeader from "./DriverDetailHeader";
import useColumns from "./useColumns";
import TransactionHistoryDrawer from "./TransactionHistoryDrawer";

const LOCAL_DEFAULT_LIMIT = 10;

const DriverDetailScreen = () => {
  const dispatch = useDispatch();

  const {
    selectedPayment,
    driverTripPaymentDetails,
    driverSessionPaymentDetails,
    driverPaymentDetailsKPI,
  } = useSelector((state) => state.revenue);

  const [selectedTab, setSelectedTab] = useState(DRIVER_OPERATION_TYPE.TRIP);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [historyDrawer, setHistoryDrawer] = useState(false);
  const [filters, setFilters] = useState({
    type: 0,
    dateRangeStart: "",
    dateRangeEnd: "",
  });

  const columns = useColumns(selectedTab);

  const data =
    selectedTab === DRIVER_OPERATION_TYPE.TRIP
      ? driverTripPaymentDetails
      : driverSessionPaymentDetails;

  const debounceSearch = useDebounce(search, 500);

  useEffect(() => {
    const filterObj = {
      driverId: selectedPayment?.entityId,
      type: selectedTab,
      offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      limit: (currentPage || 1) * LOCAL_DEFAULT_LIMIT,
    };

    if (debounceSearch) filterObj.searchQuery = debounceSearch;

    if (filters.dateRangeStart !== "" && filters.dateRangeEnd !== "") {
      filterObj.startDate = filters.dateRangeStart;
      filterObj.endDate = filters.dateRangeEnd;
    }

    if (selectedTab === DRIVER_OPERATION_TYPE.TRIP) {
      dispatch(getDriverTripPaymentDetails(filterObj));
    }

    if (selectedTab === DRIVER_OPERATION_TYPE.SESSION) {
      dispatch(getDriverSessionPaymentDetails(filterObj));
    }
  }, [
    dispatch,
    selectedPayment,
    currentPage,
    debounceSearch,
    filters,
    selectedTab,
  ]);

  // fetch payment details kpi
  useEffect(() => {
    dispatch(
      getDriverPaymentDetailsKPI({
        entityId: selectedPayment?.entityId,
        entityType: selectedPayment?.entityType,
      }),
    );
  }, [dispatch, selectedPayment]);

  return (
    <div className="w-full h-full">
      <div className="w-full bg-background">
        {/* only rendering for UI, integration remaining */}
        <div className="w-full flex items-center gap-x-6 p-6">
          {PaymentDetailsKPIData(driverPaymentDetailsKPI).map((item) => (
            <CustomKPI
              key={item.title}
              title={item.title}
              count={item.count}
              countColor={item.countColor}
              background={item.background}
              image={item.icon}
              unit="KSH"
            />
          ))}
        </div>

        <DriverDetailHeader
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setCurrentPage={setCurrentPage}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          setHistoryDrawer={setHistoryDrawer}
        />

        <div
          className={`h-[calc(100vh-72px-128px-70px-38px)] ${
            data?.result?.length && "overflow-y-scroll"
          }`}
        >
          <CustomTable
            disableScroll
            columns={columns}
            data={data?.result}
            emptyState={
              <FinanceHoverIcon size={16} className="text-dark-grey-text" />
            }
            emptyStateHeight="420px"
            rowClassName="group"
            pagination={{
              pageSize: LOCAL_DEFAULT_LIMIT,
              total: data?.totalRecords,
              showSizeChanger: false,
              onChange: (page) => {
                setCurrentPage(page);
              },
              current: currentPage,
              itemRender: (current, type, originalElement) => {
                const lastPage = data.totalRecords / current;

                if (type === "prev" && current === 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{
                        pointerEvents: "none",
                      }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "prev" && current > 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next" && lastPage <= 10) {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{ pointerEvents: "none" }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next") {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                return originalElement;
              },
            }}
          />
        </div>
      </div>

      <TransactionHistoryDrawer
        visible={historyDrawer}
        operationType={selectedTab}
        onCancel={() => setHistoryDrawer(false)}
      />
    </div>
  );
};

export default DriverDetailScreen;
